import { InjectionToken, Provider } from '@angular/core';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { Action, ActionReducer, ActionReducerMap } from '@ngrx/store';
import { mutationsReducer } from 'src/store/mutations/mutations-reducer';
import { createEntityStoresReducer } from 'src/util/entity-store/entity-store.reducer';
import { AppState } from './appstate';
import { authReducer } from './auth/auth-store.reducer';
import { EntityStores } from './generated/client-sync.generated';
import { pubnubReducer } from './pubnub/pubnub-store.reducer';
import { RouterStateUrl } from './router/router-store';

const routerReducerTypeAssertion: ActionReducer<RouterReducerState<RouterStateUrl>> = (
  state: RouterReducerState<RouterStateUrl> | undefined,
  action: Action,
) =>
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  routerReducer(state!, action as any);

export function createReducers() {
  const reducers: ActionReducerMap<AppState> = {
    entityStores: createEntityStoresReducer(new EntityStores()),
    pubnub: pubnubReducer,
    router: routerReducerTypeAssertion,
    mutations: mutationsReducer,
    auth: authReducer,
  };
  return reducers;
}

export const reducerToken = new InjectionToken<ActionReducerMap<AppState>>('reducers');

export const reducerProvider: Provider = [{ provide: reducerToken, useFactory: createReducers }];
